module.exports = __webpack_public_path__ + "images/img-3u2KzKF.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/en/2.png
// module id = 2322
// module chunks = 0